/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { DistillationColumnA } from "./modelDistillationColumnA";

class ControllerDistillationColumnA extends ControllerModel {
    constructor() {
        super("ControllerDistillationColumnA");

        this.setNewNode = (callback) => {
            let distillationColumnA = new DistillationColumnA();
            distillationColumnA.decorate(callback);

            this.addNode(distillationColumnA);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let distillationColumnA = new DistillationColumnA();
            distillationColumnA.copyFrom(node);
            distillationColumnA.decorate(callback);
            this.addNode(distillationColumnA)
        }

        this.getProperties = async (node) => {
            let n = new DistillationColumnA();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new DistillationColumnA();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerDistillationColumnA };